import React from 'react';
import { Field } from 'redux-form';
import Text from './Text/Text'
import File from './File/File'
import Select from './Select/Select'
import Textarea from './Textarea/Textarea'
import Textarea2 from './Textarea2/Textarea'
import Datetime from './Datetime'


const InputField = ({name, names, type, icon, label, unit, inputState, disabled, options}) => {

    
    const types = {
	text: {component: Text, type: 'text', field: Field},
	select: {component: Select, type: 'select', field: Field},
	textarea: {component: Textarea, type: 'textarea', field: Field},
	textarea2: {component: Textarea2, type: 'textarea', field: Field},
	password: {component: Text, type: 'password', field: Field},
	decimal: {component: Text, type: 'text', field: Field},
	file: {component: File, type: 'hidden', field: Field},
	datetime: {component: Datetime, type: 'hidden', field: Field},
    }

    const normalizers = {

	text: null,
	decimal: (value, previousValue, allValues) => {
	    const number = parseFloat(value.replace(/\./g, '').replace(/,/g, '.'))
	    if(value.length === 0)
		return ''
	    else if(isNaN(number) === true)
		return previousValue
	    else
		return number.toLocaleString('it-IT', {maximumFractionDigits: 2})+(value[value.length-1] === ',' ? ',' : '')    
	}
    }
    
    const FieldType = types[type].field
    return (
	<FieldType name={name} options={options} names={names} type={types[type].type} icon={icon}  normalize={normalizers[type]} unit={unit} component={types[type].component}  label={label} inputState={inputState} disabled={disabled} />
    )
}

export default InputField



// WEBPACK FOOTER //
// ./src/components/Inputs/InputField.jsx